export const SETSOURCELIST = "SETSOURCELIST";
export const SETSTAGELIST = "SETSTAGELIST";
export const SETVERTICALLIST = "SETVERTICALLIST";
export const SETSTATUSLIST = "SETSTATUSLIST";
export const SETTASKSTATUSLIST = "SETTASKSTATUSLIST";
export const SETUSERROLESLIST = "SETUSERROLESLIST";
export const SETROLEAUTHORIZATIONLIST = "SETROLEAUTHORIZATIONLIST";
export const SETAUTHORIZEDPAGES = "SETAUTHORIZEDPAGES";
export const SETUSERLIST = "SETUSERLIST";
export const SETADVANCESERIESLIST = "SETADVANCESERIESLIST";
export const SETADVANCESETTING = "SETADVANCESETTING";
export const SETACCOUNTLIST = "SETACCOUNTLIST";
export const SETPROJECTTYPELIST = "SETPROJECTTYPELIST";
export const SETPROJECTSTATUSLIST = "SETPROJECTSTATUSLIST";
export const SETTICKETLEVELLIST = "SETTICKETLEVELLIST";
export const SETTICKETPRIORITYLIST = "SETTICKETPRIORITYLIST";
export const SETTICKETSTATUSLIST = "SETTICKETSTATUSLIST";
export const SETDEPARTMENTLIST = "SETDEPARTMENTLIST";
export const SETDEPARTMENTDETAIL = "SETDEPARTMENTDETAIL";
export const CLEARDOC = "CLEARDOC";
export const SETNOTIFICATIONLIST = "SETNOTIFICATIONLIST";
export const SETHISTORYLIST = "SETHISTORYLIST";
